export const appointmentConstants = {
    GETAPPOINTMENTS_LIST_REQUEST: "USERS_GETAPPOINTMENTS_LIST_REQUEST",
    GETAPPOINTMENTS_LIST_SUCCESS: "USERS_GETAPPOINTMENTS_LIST_SUCCESS",
    GETAPPOINTMENTS_LIST_FAILURE: "USERS_GETAPPOINTMENTS_LIST_FAILURE",
  
    SET_ADMIN_STATUS_REQUEST: "SET_ADMIN_STATUS_REQUEST",
    SET_ADMIN_STATUS_SUCCESS: "SET_ADMIN_STATUS_SUCCESS",
    SET_ADMIN_STATUS_FAILURE: "SET_ADMIN_STATUS_FAILURE",
  
    GETPATIENTS_LIST_REQUEST: "USERS_GETPATIENTS_LIST_REQUEST",
    GETPATIENTS_LIST_SUCCESS: "USERS_GETPATIENTS_LIST_SUCCESS",
    GETPATIENTS_LIST_FAILURE: "USERS_GETPATIENTS_LIST_FAILURE",
  
    CREATEAPPOINTMENT_REQUEST: "USERS_CREATEAPPOINTMENT_REQUEST",
    CREATEAPPOINTMENT_SUCCESS: "USERS_CREATEAPPOINTMENT_SUCCESS",
    CREATEAPPOINTMENT_FAILURE: "USERS_CREATEAPPOINTMENT_FAILURE",
  
    CANCELAPPOINTMENT_REQUEST: "USERS_CANCELAPPOINTMENT_REQUEST",
    CANCELAPPOINTMENT_SUCCESS: "USERS_CANCELAPPOINTMENT_SUCCESS",
    CANCELAPPOINTMENT_FAILURE: "USERS_CANCELAPPOINTMENT_FAILURE",
  
    CREATEAPPOINTMENTS_REQUEST: "USERS_CREATEAPPOINTMENTS_REQUEST",
    CREATEAPPOINTMENTS_SUCCESS: "USERS_CREATEAPPOINTMENTS_SUCCESS",
    CREATEAPPOINTMENTS_FAILURE: "USERS_CREATEAPPOINTMENTS_FAILURE",
  
    DELETEAPPOINTMENTS_REQUEST: "USERS_DELETEAPPOINTMENTS_REQUEST",
    DELETEAPPOINTMENTS_SUCCESS: "USERS_DELETEAPPOINTMENTS_SUCCESS",
    DELETEAPPOINTMENTS_FAILURE: "USERS_DELETEAPPOINTMENTS_FAILURE",
  
    PATIENTS_LIST_REQUEST: "PATIENTS_LIST_REQUEST",
    PATIENTS_LIST_SUCCESS: "PATIENTS_LIST_SUCCESS",
    PATIENTS_LIST_FAILURE: "PATIENTS_LIST_FAILURE",
  
    
    ADMIN_APPOINTMENTS_REQUEST: "ADMIN_CREATEAPPOINTMENTS_REQUEST",
    ADMIN_APPOINTMENTS_SUCCESS: "ADMIN_CREATEAPPOINTMENTS_SUCCESS",
    ADMIN_APPOINTMENTS_FAILURE: "ADMIN_CREATEAPPOINTMENTS_FAILURE",
  
    
    ADMIN_UPDATEAPPOINTMENTS_REQUEST: "ADMIN_UPDATEAPPOINTMENTS_REQUEST",
    ADMIN_UPDATEAPPOINTMENTS_SUCCESS: "ADMIN_UPDATEAPPOINTMENTS_SUCCESS",
    ADMIN_UPDATEAPPOINTMENTS_FAILURE: "ADMIN_UPDATEAPPOINTMENTS_FAILURE",
  
    ADMIN_UPDATEAPPOINTMENTS_RESET: "ADMIN_UPDATEAPPOINTMENTS_RESET",
    
    GET_CALL_STATUS_SUCCESS: 'GET_CALL_STATUS_SUCCESS',
    GET_CALL_STATUS_FAILURE: 'GET_CALL_STATUS_FAILURE',
  
  
    USER_REQUEST_SESSION_REQUEST: "USER_REQUEST_SESSION_REQUEST",
    USER_REQUEST_SESSION_SUCCESS: "USER_REQUEST_SESSION_SUCCESS",
    USER_REQUEST_SESSION_FAILURE: "USER_REQUEST_SESSION_FAILURE",
  
    
    ADMIN_REQUEST_APPOINTMENTS_REQUEST: "ADMIN_REQUEST_APPOINTMENTS_REQUEST",
    ADMIN_REQUEST_APPOINTMENTS_SUCCESS: "ADMIN_REQUEST_APPOINTMENTS_SUCCESS",
    ADMIN_REQUEST_APPOINTMENTS_FAILURE: "ADMIN_REQUEST_APPOINTMENTS_FAILURE",
  
  };
  


// WEBPACK FOOTER //
// ./src/store/constants/appointment.constants.js